import React, { Suspense } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import Layout from '../components/Layout';
import LoadingSpinner from '../components/LoadingSpinner';

const Home = React.lazy(() => import('../pages/Home'));
const Calendar = React.lazy(() => import('../pages/Calendar'));
const Viagens = React.lazy(() => import('../pages/Viagens'));
const TripDetails = React.lazy(() => import('../pages/TripDetails'));
const GeneralConditions = React.lazy(() => import('../pages/GeneralConditions'));
const Seguro = React.lazy(() => import('../pages/Seguro'));
const PrivateTrips = React.lazy(() => import('../pages/PrivateTrips'));
const AboutUs = React.lazy(() => import('../pages/AboutUs'));
const Contact = React.lazy(() => import('../pages/Contact'));
const PrivacyPolicy = React.lazy(() => import('../pages/PrivacyPolicy'));
const CookiePolicy = React.lazy(() => import('../pages/CookiePolicy'));
const ConsumerDisputes = React.lazy(() => import('../pages/ConsumerDisputes'));
const ComplaintsBook = React.lazy(() => import('../pages/ComplaintsBook'));
const NotFound = React.lazy(() => import('../pages/NotFound'));

const LayoutWrapper: React.FC = () => {
  return (
    <Layout>
      <Suspense fallback={<LoadingSpinner />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<LayoutWrapper />}>
        <Route path="/" element={<Home />} />
        <Route path="/calendario" element={<Calendar />} />
        <Route path="/viagens" element={<Viagens />} />
        <Route path="/viagens/condicoes-gerais" element={<GeneralConditions />} />
        <Route path="/viagens/seguro" element={<Seguro />} />
        <Route path="/viagens/viagens-privadas" element={<PrivateTrips />} />
        <Route path="/viagens/:slug" element={<TripDetails />} />
        <Route path="/sobre-nos" element={<AboutUs />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/privacidade" element={<PrivacyPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/resolucao-conflitos" element={<ConsumerDisputes />} />
        <Route path="/livro-reclamacoes" element={<ComplaintsBook />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
